/// <reference path="../../../tools/typings/angularjs/angular.d.ts"/>
/// <reference path="./contract.ts"/>

namespace DealerwareWebServices {
    "use strict";

    export class ContractFactory implements IDealerwareContractFactory {
        public static $inject: string[] = [
            '$q',
            '$timeout',
            'DealerwareContractModel',
            'DealerwareWarrantyModel',
            '$DealerwareNotesFactory',
            '$DealerwareContractInvoiceFactory'
        ];

        constructor(public $q: any,
                    public $timeout: any,
                    public DealerwareContractModel: any,
                    public DealerwareWarrantyModel: any,
                    public $DealerwareNotesFactory : any,
                    public $DealerwareContractInvoiceFactory : any) {}

        public loadContract(locationId: number, id: number) : ng.IPromise<{}> {
            var _deferred = this.$q.defer(),
                _contract = new Contract(this.$q, this.$timeout, this.DealerwareContractModel, this.DealerwareWarrantyModel, this.$DealerwareNotesFactory, this.$DealerwareContractInvoiceFactory);

            _contract.loadContractDetails(locationId, id).then(
                function(response: ng.IHttpPromiseCallbackArg<{}>) {
                    _deferred.resolve({ contract: _contract });
                },
                function(returnValue: any) {
                    _deferred.reject({ contract: _contract, response: returnValue.response });
                }
            );

            return _deferred.promise;
        }

        public getInstance() : IDealerwareContract {
            return new Contract(this.$q, this.$timeout, this.DealerwareContractModel, this.DealerwareWarrantyModel, this.$DealerwareNotesFactory, this.$DealerwareContractInvoiceFactory);
        }
    }

    getDealerwareWebServicesModule().service("$dealerwareContractFactory", ContractFactory);
}
